import locale from './locale';

export default {
  locale,
};
